import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutZipService } from '@app/core/services-api/layout-zip.service';
import { FeatureService } from '@app/core/services/feature/feature.service';
import { first } from 'rxjs/operators';
import { MenuService } from '@app/core/services/menu/menu.service';
import { CustomHomeComponent } from '@app/custom-home/custom-home.component';
import { LocalService } from '@app/shared/services/local.service';
import { NavigationHelper } from '../util/NavigationHelper';
import { SharedVariable } from '../util/shared-variable';

@Component({
  selector: 'app-custom-menu',
  templateUrl: './custom-menu.component.html',
  styleUrls: ['./custom-menu.component.scss']
})
export class CustomMenuComponent implements OnInit {
  permissions = this.secureStorage.getJsonValue('permissions')
  bntStyle: string = "first-level-menu";
  first_active_menu: any;
  reports_menu: any;
  second_active_menu: any;
  third_active_menu: any;
  first_selectedMenuEntry: string;
  second_selectedMenuEntry: string;
  third_selectedMenuEntry: string;
  isOperationMenu: boolean = false;
  isReportsMenu: boolean = false;

  constructor(
    private secureStorage: LocalService,
    private mainComponent: CustomHomeComponent, private menuService: MenuService, private router: Router,
    private layoutZipService: LayoutZipService,
    private shared:SharedVariable,
    private featureService: FeatureService) {
  }

  ngOnInit(): void {
    this.initScreen();
    // ❌ zipBase64 - Chargé à la demande lors du téléchargement

  }

  getZipBase64(){
     this.layoutZipService.search().subscribe((res: any) => {
        this.shared.zipBase64 = res;
       });
  }
  initScreen() {
    this.first_active_menu = this.getActiveMenu(this.mainComponent.menu, 'active');
    this.second_active_menu = this.getActiveMenu(this.first_active_menu.items, 'operations');
    this.reports_menu = this.getActiveMenu(this.first_active_menu.items, 'reports');
    this.third_active_menu = this.getActiveMenu(this.second_active_menu.items, 'manual-billing');
  }

  filterMenu(menu: any[]): any[] {
    if (this.permissions) {
      return this.menuService.filterByRole(menu);
    } else {
      setTimeout(() => {
        this.permissions = this.secureStorage.getJsonValue('permissions')

        this.filterMenu(menu);
      }, 1000);
    }
  }

  async loadComponent(url: any): Promise<boolean> {
    await this.router.navigateByUrl('.', { skipLocationChange: false });
    return this.router.navigateByUrl(url[0]);
  }
  getActiveMenu(menu: any[], key: string): any {
    return menu.find(element => element.id === key);
  }
  loadUploadComponent(){
    NavigationHelper.loadComponent("/load_files/Parent_Upload", this.router);
  }
  loadNewReportComponent(){
    NavigationHelper.loadComponent("/new-reports-type", this.router);
  }
  isOperation(): boolean {
    return this.first_selectedMenuEntry === "Operations";
  }

  isManualBilling(): boolean {
    return this.second_selectedMenuEntry === "manual-billing";
  }

  firstLevelClicked(item: any) {
    this.first_selectedMenuEntry = item;
    this.isOperationMenu = item.id === 'operations' ? true : false;
    this.isReportsMenu = item.id === 'reports' ? true : false;
  }

  secondLevelClicked(item: string) {
    this.second_selectedMenuEntry = item;
    this.downloadFile(item)
  }

  downloadFile(item: string) {
    if (item === 'layouts-sc') {
      this.downloadLayoutFromBackend();
    }
  }
  downloadLayouts(filePath) {
    var link = document.createElement('a');
    link.href = filePath;
    link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
    link.click();
  }
  responseZip :any;
  private downloadLayoutFromBackend() {
    // ✅ Charger zipBase64 à la demande (lazy loading)
    if (!this.shared.zipBase64) {
      this.layoutZipService.search().subscribe((res: any) => {
        this.shared.zipBase64 = res;
        this.processDownload();
      });
    } else {
      this.processDownload();
    }
  }

  private processDownload() {
    let res: any = this.shared.zipBase64;
    // Backend always returns an array
    if (!Array.isArray(res) || res.length === 0) {
      this.featureService.translatorService
        .getMessage('nozipfoundcontactyouradministrator')
        .pipe(first())
        .subscribe(val => { (val as any).showWarn(); });
      return;
    }
    const row = res[0];
    if (!row || !row.zipContent) {
      this.featureService.translatorService
        .getMessage('nozipfoundcontactyouradministrator')
        .pipe(first())
        .subscribe(val => { (val as any).showWarn(); });
      return;
    }
    const base64 = row.zipContent;
    const name = row.zipName || 'layout.zip';
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) { byteNumbers[i] = byteChars.charCodeAt(i); }
    const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/zip' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  sortMenuEntries(list: any) {
    return list.sort(function (a, b) {
      return a.label.localeCompare(b.label);
    });
  }

}
